import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { HasAccessDirective } from '@sharedModule/directives/has-access.directive';
import { MaterialModule } from '@sharedModule/material/material.module';
import { GlobalService } from '@sharedModule/services/global.service';
import { ConversionRateComponent } from '../conversion-rate/conversion-rate.component';
import { DestinationCountryComponent } from '../destination-country/destination-country.component';
import { SourceCountryComponent } from '../source-country/source-country.component';

@Component({
  selector: 'app-countries',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    HasAccessDirective,
    SourceCountryComponent,
    DestinationCountryComponent,
    ConversionRateComponent,
  ],
  templateUrl: './countries.component.html',
  styleUrl: './countries.component.scss',
})
export class CountriesComponent {
  clickedTabIndex = 0;

  constructor(
    private router: Router,
    private globalService: GlobalService
  ) {}

  getSelectedIndex(): number {
    this.clickedTabIndex = this.globalService.currentTabIndex;
    return this.globalService.currentTabIndex;
  }

  tabClick(event: MatTabChangeEvent): void {
    this.clickedTabIndex = event.index;
    this.globalService.currentTabIndex = event.index;
  }

  addCountrySettings(data: string): void {
    this.router.navigate([data]);
  }
}
